// Remove everything that is not a letter / digit / dash
export const sanitizeAlphanumeric = (v = '') => v.replace(/[^A-Za-z0-9-]/g, '');

export type TPlaceholder = [string, string];

const replacePlaceholder = (input: string, placeholder: TPlaceholder) => {
  const [key, value] = placeholder;
  return input.replace(new RegExp(`{{{${key}}}}`, 'g'), sanitizeAlphanumeric(value));
};

export const getPlaceholderReplacer =
  (placeholdersStatic: TPlaceholder[] = []) =>
  (html: string, placeholdersDynamic: TPlaceholder[]) => {
    const placeholdersStaticReplaced = placeholdersStatic.reduce(replacePlaceholder, html);
    const placeholdersDynamicReplaced = placeholdersDynamic.reduce(
      replacePlaceholder,
      placeholdersStaticReplaced
    );

    // Remove any unused placeholders
    const finalHtml = placeholdersDynamicReplaced.replace(/{{{[aA-zZ]+}}}/g, '');

    return finalHtml;
  };
